import { Button, ButtonTheme } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

export interface WizardFooterProps {
    id: string;
    /** Hides the Back button (e.g. on the first step). */
    showBack: boolean;
    onBack: () => void;
    onContinue: () => void;
    continueText?: string;
    /** Disables only the Continue button (e.g. the current step isn't ready yet). */
    continueDisabled?: boolean;
    /** Disables both buttons (e.g. while an async continue is running). */
    disabled?: boolean;
}

/** Bottom bar for WizardModal: Back on the left, Continue on the right. */
export const WizardFooter = ({
    id,
    showBack,
    onBack,
    onContinue,
    continueText = 'Save & Continue',
    continueDisabled = false,
    disabled = false,
}: WizardFooterProps) => {
    return (
        <>
            {/* Empty placeholder keeps Continue right-aligned when Back is hidden */}
            {showBack ? (
                <Button
                    id={`${id}_back`}
                    theme={ButtonTheme.LinkBlue}
                    handleClick={onBack}
                    disabled={disabled}
                >
                    <FontAwesomeIcon icon={faChevronLeft} /> Back
                </Button>
            ) : (
                <span />
            )}
            <Button
                id={`${id}_continue`}
                handleClick={onContinue}
                width='250px'
                disabled={disabled || continueDisabled}
            >
                {continueText}
            </Button>
        </>
    );
};
